export default __webpack_public_path__ + "crane.png?e1089af10566b725dc8f843d093c0675";